import { SingleValue } from "react-select";
import { BinInfo, ContainerList, RecylcableList } from "../staticInfo/state";
import { AttendanceCollectionInfo, CollectionDetail, CollectionPhotoList, UnloadCollectionInfo, UnloadImageList } from "./state";




export function initCollectionDetailAction(collectionDetail:CollectionDetail[],signature_image:string,signature_image_thumb:string,collectionPhotoList:CollectionPhotoList[]){
    return {
        type: '@@collectionState/initCollectionDetailAction' as const ,
        collectionDetail,
        signature_image,
        signature_image_thumb,
        collectionPhotoList
    }
}


export function initCollectionAttendanceAction(attendanceCollectionInfo:AttendanceCollectionInfo[]){
    return {
        type: '@@collectionState/initCollectionAttendanceAction' as const ,
        attendanceCollectionInfo
    }
}

export function initUnloadDataAction (unloadCollectionInfo:UnloadCollectionInfo[]){
    return {
        type: '@@collectionState/initUnloadDataAction' as const ,
        unloadCollectionInfo
    }
}

export function initUnloadImageAction(unloadImageList:UnloadImageList[]){
    return {
        type: '@@collectionState/initUnloadImageAction' as const ,
        unloadImageList
    }
}

export function initSelectedEditattendanceAction(attendanceCollectionInfo:AttendanceCollectionInfo){
    return {
        type: '@@collectionState/initSelectedEditattendanceAction' as const ,
        attendanceCollectionInfo
    }
}

export function changeBinInfoAction(binInfo:SingleValue<BinInfo>){
    return {
        type: '@@collectionState/changeBinInfoAction' as const ,
        binInfo
    }
}

export function ChangeAttendaceDateTimeAction(date:Date | moment.Moment ){
    return {
        type: '@@collectionState/ChangeAttendaceDateTimeAction' as const ,
        date
    }
}

export function handleCollectionDateAction(date:Date){
    return {
        type: '@@collectionState/handleCollectionDateAction' as const ,
        date
    }
}

export function initSelectedEditionCollectionDetailAction(collectionDetail:CollectionDetail){
    return {
        type: '@@collectionState/initSelectedEditionCollectionDetailAction' as const ,
        collectionDetail
    }
}

export function ChangeRecyclabeAction(targetReyclableInfo: RecylcableList){
    return {
        type: '@@collectionState/ChangeRecyclabeAction' as const ,
        targetReyclableInfo
    }
}

export function ChangeContainerAction(targetContainerInfo: ContainerList,collection_weight:string){
    return {
        type: '@@collectionState/ChangeContainerAction' as const ,
        targetContainerInfo,
        collection_weight
    }
}

export function ChangeCollectionWeightAction(collection_weight: string,targetContainerInfo: ContainerList){
    return {
        type: '@@collectionState/ChangeCollectionWeightAction' as const ,
        collection_weight,
        targetContainerInfo
    }
}

export function ChangeCollectionDetailAction(collectionDetail:CollectionDetail[]){
    return {
        type: '@@collectionState/ChangeCollectionDetailAction' as const ,
        collectionDetail
    }
}

export function InitSelectedUnloadCollectionAction(unloadCollectionInfo:UnloadCollectionInfo){
    return {
        type: '@@collectionState/InitSelectedUnloadCollectionAction' as const ,
        unloadCollectionInfo
    }
}

export function ChangeUnloadCollectionDepotAction(depot_id:string){
    return {
        type: '@@collectionState/ChangeUnloadCollectionDepotAction' as const ,
        depot_id
    }
}

export function ChangeUnloadCollectionMetalAction(metal_weight:string,total_weight:string){
    return {
        type: '@@collectionState/ChangeUnloadCollectionMetalAction' as const ,
        metal_weight,
        total_weight
    }

}

export function ChangeUnloadCollectionPaperAction(paper_weight:string,total_weight:string){
    return {
        type: '@@collectionState/ChangeUnloadCollectionPaperAction' as const ,
        paper_weight,
        total_weight
    }
}
export function ChangeUnloadCollectionPlasticAction(plastic_weight:string,total_weight:string){
    return {
        type: '@@collectionState/ChangeUnloadCollectionPlasticAction' as const ,
        plastic_weight,
        total_weight
    }
}

export function ChangeUnloadCollectionTotalWeightAction (total_weight:string){
    return {
        type: '@@collectionState/ChangeUnloadCollectionTotalWeightAction' as const ,
        total_weight
    }
}
export function ChangeCollectionPhotoListAction(collectionPhotoList:CollectionPhotoList[]){
    return {
        type: '@@collectionState/ChangeCollectionPhotoListAction' as const ,
        collectionPhotoList
    }
}

export function ChangeSignatureImageAction(signature_image:string){
    return {
        type: '@@collectionState/ChangeSignatureImageAction' as const ,
        signature_image
}
}


export type CollectionAction =

|ReturnType<typeof initCollectionDetailAction>
|ReturnType<typeof initCollectionAttendanceAction>
|ReturnType<typeof initUnloadDataAction>
|ReturnType<typeof initUnloadImageAction>
|ReturnType<typeof initSelectedEditattendanceAction>
|ReturnType<typeof changeBinInfoAction>
|ReturnType<typeof ChangeAttendaceDateTimeAction>
|ReturnType<typeof handleCollectionDateAction>
|ReturnType<typeof initSelectedEditionCollectionDetailAction>
|ReturnType<typeof ChangeRecyclabeAction>
|ReturnType<typeof ChangeContainerAction>
|ReturnType<typeof ChangeCollectionWeightAction>
|ReturnType<typeof ChangeCollectionDetailAction>
|ReturnType<typeof InitSelectedUnloadCollectionAction>
|ReturnType<typeof ChangeUnloadCollectionDepotAction>
|ReturnType<typeof ChangeUnloadCollectionMetalAction>
|ReturnType<typeof ChangeUnloadCollectionPaperAction>
|ReturnType<typeof ChangeUnloadCollectionPlasticAction>
|ReturnType<typeof ChangeUnloadCollectionTotalWeightAction>
|ReturnType<typeof ChangeCollectionPhotoListAction>
|ReturnType<typeof ChangeSignatureImageAction>
